import { Box, Button, Typography } from 'hephaestus/web';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export type WatchListFooterProps = {
  /** Number of rows currently shown in the table. */
  shown: number;
  /** Band-consumed threshold percentage, e.g. 75. */
  approachThreshold: number;
  /**
   * When provided, a "Configure" link is rendered after the threshold copy.
   * When undefined the link is hidden — avoids shipping a dead control until
   * the destination is wired. Mirrors the `onViewAllClick` pattern.
   */
  onConfigureClick?: () => void;
};

export const WatchListFooter: FC<WatchListFooterProps> = ({
  shown,
  approachThreshold,
  onConfigureClick,
}) => {
  const { t } = useTranslation('watchList');

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mt: 2,
        mb: 2,
        px: 1,
      }}
    >
      <Typography variant='bodySmall' color='textSecondary'>
        {t('footer.rowCount', { count: shown })}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant='bodySmall' color='textSecondary'>
          {t('footer.threshold', { percent: approachThreshold })}
        </Typography>

        {onConfigureClick && (
          <Button variant='text' size='small' onClick={onConfigureClick}>
            {t('footer.configure')}
          </Button>
        )}
      </Box>
    </Box>
  );
};
